import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';
import './newStudyStepSkeleton.scss';

/**
 * Placeholder shown while a create-study wizard step is still fetching its data. Maps over a fixed range of ten entries rendering a header and content Skeleton pair for each, and appends a 24 pixel spacer after the last item.
 *
 * @returns Skeleton placeholder element for a wizard step.
 */
const NewStudyStepSkeleton = () => {
  const MAX_SKELETON_ITEMS = 10;

  return (
    <div className="new-study-step-skeleton-container">
      <div id="skeleton-container" className="skeleton-container">
        {_.range(MAX_SKELETON_ITEMS).map((item, index) => (
          <div>
            <div {...({ index: item } as any)} className="skeleton-item-container">
              <div className="header-skeleton">
                <Skeleton />
              </div>
              <div className="content-skeleton">
                <Skeleton />
              </div>
            </div>
            {index === MAX_SKELETON_ITEMS - 1 && <div style={{ height: 24 }} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewStudyStepSkeleton;
